import {
  ExpertScreenerActionStatusMap,
  IExpertScreenerAction,
} from '../models/expertScreenerActions.models';

export const baseExpertScreenerActionMock: IExpertScreenerAction = {
  expertActionId: 'expertActionId',
  clientId: 'clientId',
  opportunityId: 'opportunityId',
  expertId: 'expertId',
  ownerUserId: 'connectId',
  actionType: 'screener',
  status: ExpertScreenerActionStatusMap.CompleteNearPass,
  contactId: 'contactId',
  contactLookupId: 'otherContactLookupId',
  dateSent: 1234,
  distributionId: 'distributionId',
  distributionType: 'email',
  reminderIds: [],
  surveyId: 'surveyId',
  dateCreated: 0,
  lastUpdated: 0,
};
